import Highlights from './Highlights'

export * from './Highlights'

export default Highlights
